import { AppStatusDao } from '@rock/db-admin';
import type { AppStatusDocKind } from '@rock/types';
import { atom } from 'jotai';
import { atomFamily } from 'jotai/utils';

const appStatusDao = new AppStatusDao();

/** Live doc per tool — what users see right now. Union-typed; narrow with the `object` field if needed. */
export const appStatusLiveState = atomFamily((kind: AppStatusDocKind) => appStatusDao.appStatusDocAtom(kind));

/** Draft/publish status per tool (drives the "unpublished changes" badge + Publish gating). */
export const appStatusDraftStatusState = atomFamily((kind: AppStatusDocKind) =>
    appStatusDao.appStatusDraftStatusAtom(kind),
);

/**
 * What an editor form opens with: the staged draft if one exists, else the live doc. One export
 * per kind (not a family) so each page gets its exact doc type. Read-only — saves stage through
 * `useAppStatusActions(kind).saveDraft` (the DraftLayer choke point that stamps `_draft: true`).
 */
const editDocState = <K extends AppStatusDocKind>(kind: K) => {
    const draftAtom = appStatusDao.appStatusDraftAtom(kind);
    const liveAtom = appStatusDao.appStatusDocAtom(kind);
    return atom(async (get) => (await get(draftAtom)) ?? (await get(liveAtom)));
};
export const alertEditDocState = editDocState('alert');
export const requiredUpgradeEditDocState = editDocState('required-upgrade');
export const easUpdateEditDocState = editDocState('eas-update');
export const maintenanceEditDocState = editDocState('maintenance');
export const storeUrlsEditDocState = editDocState('store-urls');
